export default __webpack_public_path__ + "static/vehicle_warranty_4-d86a376553704e1d99bae24a41a14d73.jpeg";